export const FETCH_SUGGESTION = "FETCH_SUGGESTION";
export const FETCH_SUGGESTIONS = "FETCH_SUGGESTIONS";